export default __webpack_public_path__ + "static/media/yo5.fa1176fc.png";